// @flow

import './DemoRedirectContainer.css';

import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Redirect} from 'react-router-dom';
import {demoLogin} from '../../actions/auth';
import LoadingIndicator from '../../components/LoadingIndicator/LoadingIndicator';


export type Props = {
  projectName: String,
  isAuthenticated: Boolean,
  isFetching: Boolean,
  error: Object,
  loginDemoProject: Function,
};

class DemoRedirectContainer extends Component<Props> {
  props: Props;

  componentWillMount() {
    this.props.loginDemoProject(this.props.projectName);
  }

  render() {
    const {projectName, isAuthenticated, isFetching, error} = this.props;

    if (isFetching) {
      return <div>
        Logging in demo user
        <LoadingIndicator isLoading={isFetching} />
      </div>;
    }

    if (isAuthenticated) {
      return <Redirect to="/" />;
    }
    return (
      <div className="demo-redirect-error-container">
        <div className="callout alert w-100">
          <p>
            <span className="f-bold">Misslyckades logga in demo användare</span>
          </p>
          <p>
            Projekt: {projectName}
            <br></br>
            Fel: {error}
          </p>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({
  auth: {isAuthenticated, isFetching, error},
}) => ({
  isAuthenticated,
  isFetching,
  error,
});


export default connect(
  mapStateToProps,
  dispatch => ({
    loginDemoProject: (username, password) =>
      dispatch(demoLogin(username, password)),
  })
)(DemoRedirectContainer);



// WEBPACK FOOTER //
// ./src/containers/DemoRedirectContainer/DemoRedirectContainer.js